<template>
  <div>222</div>
  <!-- <div class="my_input_select" :style="{ width: this.current.cptWidth + 'px', height: this.current.cptHeight + 'px' }">
    <transition-group name="fade" tag="div">
      <div
        v-for="(item, i) in visibleItems"
        :key="i"
        class="my_input_select_item"
        ref="itemRefs"
        :style="setStyles"
      >
        {{ item.label }}
      </div>
    </transition-group>
    <button @click="showAllItems" v-if="showMoreButtons">显示更多</button>
  </div> -->
</template>

<script>

export default {
  name: "cpt-input-select",
  props: {
    option: Object,
    refMap: Object,
    current: Object,
  },
 computed: {
    setStyles() {
      return {
        "--top": this.option.attribute.top + "px",
        "--bottom": this.option.attribute.bottom + "px",
        "--left": this.option.attribute.left + "px",
        "--right": this.option.attribute.right + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--activeBgColor":this.option.attribute.activeBgColor,
        "--activeBrColor":this.option.attribute.activeBrColor,
        "--activeColor":this.option.attribute.activeColor,
      };
    },
  },
  data() {
    return {
      expandedList: [],
      visibleItems: [],
      showMoreButtons: false,
      isAdjustingVisibleItems: false,
      // adjustVisibleItemsDebounced: debounce(this.adjustVisibleItems, 300),
    };
    // 
// 请认真看需求,并书写以下代码
// 1,this.current.cptWidth 与 this.current.cptHeight 是动态的宽高
// 2,每个itemRefs 的宽高是自适应
// 3,需求1,当每个itemRefs 的宽高超出this.current.cptWidth 与 this.current.cptHeight ,就显示更多按钮,其余隐藏.没有超出,就不用显示更多按钮
// 4,需求2,渲染完后,当用户更改this.current.cptWidth 与 this.current.cptHeight,要重新根据this.current.cptWidth 与 this.current.cptHeight重新计算每个itemRefs 的宽高,然后重新渲染,也需要判断当每个itemRefs 的宽高超出this.current.cptWidth 与 this.current.cptHeight ,就显示更多按钮,其余隐藏.没有超出,就不用显示更多按钮
// 5,需求3,当用户点击显示更多按钮,就显示所有itemRefs
  },
  mounted() {
    // console.log(this.current.cptWidth, this.current.cptHeight);
    // const list = [{ label: "测试", value: "1" }, { label: "测试2", value: "2" },];
    // let cycleLength = list.length;
    // this.expandedList = new Array(20).fill(null).map((_, index) => list[index % cycleLength]);
    // this.visibleItems = [...this.expandedList];
    //   this.$nextTick(() => {
    //   this.adjustVisibleItems();
    // });
    
  },
  created() {
   

  },
  watch: {
    'current.cptWidth': {
      handler(newWidth, oldWidth) {
        if (!this.isAdjustingVisibleItems) {
          this.isAdjustingVisibleItems = true;
          this.adjustVisibleItemsDebounced();
        }
      },
      deep: true,
    },
    'current.cptHeight': {
      handler(newHeight, oldHeight) {
        if (!this.isAdjustingVisibleItems) {
          this.isAdjustingVisibleItems = true;
          this.adjustVisibleItemsDebounced();
        }
      },
      deep: true,
    },
  },
  methods: {
    adjustVisibleItems() {
       this.showMoreButtons = false;
      let totalWidth = 0;
      let totalHeight = 0;

      // 清空 visibleItems，然后重新填充直到超出容器尺寸
      this.visibleItems = [];
     for (let i = 0; i < this.expandedList.length; i++) {
        this.visibleItems.push(this.expandedList[i]);

        const itemRect = this.$refs.itemRefs[this.visibleItems.length - 1]?.getBoundingClientRect();

        if (itemRect) {
          totalWidth += itemRect.width;
          totalHeight += itemRect.height;

          if (totalWidth > this.current.cptWidth || totalHeight > this.current.cptHeight) {
            this.visibleItems.pop();
            this.showMoreButtons = true;
            break;
          }
        }
      }
    },
    showAllItems() {
      this.visibleItems = [...this.expandedList];
      this.showMoreButtons = false;
    },
  },
};
</script>

<style scoped>
.my_input_select {
  width: 100%;
}
.my_input_select_item { 
  padding:var(--top) var(--right) var(--bottom) var(--left);
  background-color: var(--bgColor);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  border:var(--borderSize) var(--lineType) var(--borderColor);
  border-radius: var(--borderRadius);
  display: inline-block;
  margin-left: 10px;
  box-sizing: border-box;
  white-space: nowrap;
  box-shadow: none;
}
</style>
